<template>
  <div class="page">
    <div class="m-page">
      <div class="x-flex-between">
        <div>
          <span class="x-font-color x-font-15 m-user">申请注册</span>
        </div>
        <span class="x-font-12"></span>
      </div>
      <p class="m-p">请填写真实的姓名及证件号码，证件号码为登录账号，无法 修改！</p>
      <transition name="van-fade">
        <mTabNav1 ref="mTab1" v-show="keys==1" :isRegister="2" @isOK="isOK"/>
      </transition>
      <transition name="van-fade">
        <mTabNav2 ref="mTab2" v-show="keys==2" :isRegister="2" @isOK="isOK" @submit="submit"/>
      </transition>
    </div>
  </div>
</template>

<script>
  import mTabNav1 from "./components/m-tab-nav1"
  import mTabNav2 from "./components/m-tab-nav2"
  export default {
    components: {mTabNav1,mTabNav2},
    data () {
      return {
        keys:1,
//        titleName:'',
      }
    },
    created () {
//      this.getTitle()
    },
    methods: {
      isOK(i,y){
        this.keys = i
        if(y){
          this.$refs.mTab2.idCardNum = y
        }
      },
      //提交申请
      submit(){
        let idCardNum = this.$refs.mTab1.form.idCardNum
        this.http.postRequest({
          url:'app/userInfo/applyInsert',
          msg:{idCardNum},
          success:(res)=>{
            this.utils.toastSuccess('申请成功!')
            this.$router.replace({
              path:'/applySuccess'
            })
          }
        },true)
      },
//      getTitle(){
//        this.http.getRequest({
//          url:'app/userInfo/tenantNoLogin',
//          msg:{},
//          success:(res)=>{
//
//          }
//        })
//      },
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    background: #F4F6F9;
    .m-page{
      position: absolute;
      top: 12px;
      left: 12px;
      right: 12px;
      bottom: 12px;
      margin: auto;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      z-index: 2;
      background: #ffffff;
      border-radius: 4px;
      padding: 15px;
      .m-user{
        border-left: 3Px solid #457DF9;
        padding-left: 4px;
      }
      .m-p{
        margin-top: 8px;
        font-size: 12px;
        color: #FB2927;
        margin-bottom: 20px;
        line-height: 16px;
      }
    }
  }
</style>

